module.exports = __webpack_public_path__ + "img/hero01.b3ee6c6c.jpg";